import { useMemo } from 'react';

/** The slice of an infinite query that a paged tree level needs to load the rest of itself. */
export type TreePagination = {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isFetchNextPageError: boolean;
};

/**
 * Picks the paging state off an infinite query as one stable object, so it can be handed to memoized tree rows
 * without re-rendering them on every render of the component that owns the query.
 */
export const useTreePagination = ({
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isFetchNextPageError,
}: TreePagination): TreePagination =>
  useMemo(
    () => ({ fetchNextPage, hasNextPage, isFetchingNextPage, isFetchNextPageError }),
    [fetchNextPage, hasNextPage, isFetchingNextPage, isFetchNextPageError],
  );
